"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constants = require("../constants");
var _Label = _interopRequireDefault(require("./Label.style"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
let Label = (_dec = (0, _reactJss.default)(_Label.default), _dec(_class = class Label extends _react.PureComponent {
  render() {
    const {
      classes,
      fontSize,
      fontWeight,
      color,
      textColor,
      className,
      value,
      id,
      error,
      visibility,
      onClick,
      onMouseEnter,
      onMouseLeave,
      overflow,
      duplicatingTooltip,
      textAlign,
      style,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("span", {
      title: duplicatingTooltip ? value : null,
      id: id,
      className: (0, _clsx.default)(className, classes.label, classes[`color__${color}`], classes[`fontSize__${fontSize}`], classes[`fontWeight__${fontWeight}`], textAlign ? classes[`textAlign__${textAlign}`] : null, overflow ? classes[`overflow__${overflow}`] : null, {
        error: !!error
      }, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }),
      style: _objectSpread({
        color: textColor
      }, style),
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      "data-testid": dataTestId
    }, value);
  }
}) || _class);
Label.COLOR = _constants.COLOR;
Label.OVERFLOW = {
  /**
   * Only one string will be left and ellipse added if possible.
   * Can be used even if Label width is not specified directly, including flexbox items, etc.
   */
  cut: 'cut',
  /** Breaks long words that cannot be placed in one line */
  break: 'break',
  style: {}
};
Label.SIZES = _constants.LABEL_FONT_SIZE;
Label.WEIGHTS = _constants.LABEL_FONT_WEIGHT;
Label.ALIGNMENTS = _constants.LABEL_TEXT_ALIGN;
Label.defaultProps = {
  fontSize: _constants.LABEL_FONT_SIZE.medium,
  fontWeight: _constants.LABEL_FONT_WEIGHT.normal,
  visibility: 'visible',
  error: false,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {}
};
var _default = exports.default = Label;